import React from 'react';
import { useLocation } from 'react-router-dom';
import Seo from './Seo';
import { getPageMeta } from '../../config/seo';

const BLOG_ARTICLE_PATTERN = /^\/blog\/[^/]+$/;

const PageSeo = () => {
    const { pathname } = useLocation();

    if (BLOG_ARTICLE_PATTERN.test(pathname)) {
        return null;
    }

    const meta = getPageMeta(pathname);

    return (
        <Seo
            title={meta.title}
            description={meta.description}
            canonicalPath={meta.canonicalPath}
            keywords={meta.keywords}
        />
    );
};

export default PageSeo;
